// extracted by mini-css-extract-plugin
export default {"button":"PrintResults_button__70OMP","row":"PrintResults_row__R1JAa"};